import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Async action
export const fetchW4CountStatus = createAsyncThunk("fetchW4CountStatus", async ({ identifier, sub }, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};

		let url = `status/count?module=${identifier}&sub=${sub}`;

		const response = await axiosHttp.get(url, config);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || error.message);
	}
});

// Slice
const WfourCountsSlice = createSlice({
	name: "WfourCountsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder
			.addCase(fetchW4CountStatus.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchW4CountStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchW4CountStatus.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || "An unexpected error occurred.";
			});
	},
});

export default WfourCountsSlice.reducer;
